import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const GeoModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Geo">
          <g id="group200">
            <path
              fill={fillColor200}
              opacity="0.25"
              d="M364.37,647.37S186.66,625,116.68,456.64c-61.11-147,.23-217,18.76-230.22,32.17-22.93,90.72-6.52,202.78,78.33C405.94,356,487.66,302,528.92,203.23s58.78-96.62,73.46-92.06c49.26,15.31,87,71.79,88.79,172.69S669.35,529,593.31,587,404.65,651.56,364.37,647.37Z"
            />
          </g>
          <g id="group400">
            <path
              fill={fillColor400}
              opacity="0.2"
              d="M334.42,147.15a38.46,38.46,0,0,1,9.09,50.55c-7,11.39-30.67,23.48-42,36.62-31.15,36.07-12.94,35.82-41.54,44.31-22.59,6.7-57.88-15-72.27-56.1S189.63,138,204.1,135c23.56-4.89,40,4.55,74.84,7.55C298.35,144.26,322.07,137.5,334.42,147.15Z"
            />
            <path
              fill={fillColor400}
              opacity="0.2"
              d="M670.21,430.53a48.41,48.41,0,0,1-61.4-20.21c-8.4-14.59-7.62-48-15.37-68.44-21.27-56.07-31.9-35.77-24.17-72.5,6.11-29,51.24-55.11,105.38-46.41s92.35,52.76,87,70.58c-8.7,29-29,41.56-53.17,78.3C695,392.34,688.28,422.64,670.21,430.53Z"
            />
          </g>
          <g id="group600">
            <path
              fill={fillColor600}
              d="M128.28,362.65S145.55,189.19,261.58,146c139-51.79,119.39,31.57,257.9,163.79C689.63,472.15,745.63,370,756.57,469.59c7.5,68.3-69.12,105.43-92.36,115.45S502,624.54,472.8,634.71s-141,51.43-182.29,44.51S172,652.49,142.63,542.43,124.86,394.78,128.28,362.65Z"
            />
            <path
              fill={fillColor600}
              d="M95.61,442.09c-.6,14.3.66,37.09-11.75,46.83-13.53,10.62-30.34,5-35.29-12.21C39.28,444.41,95.18,432,95.61,442.09Z"
            />
            <path
              fill={fillColor600}
              d="M636.52,379.6c-4.45-3.69-1.73-11,4.05-10.67,24.95,1.42,47.7-9.05,70.73-18.53,26-10.69,41.69-21.36,33.55,14.69C732.24,421,659.47,398.63,636.52,379.6Z"
            />
            <path
              fill={fillColor600}
              d="M502.22,671.27a9.67,9.67,0,1,1-16.71-9.72c2.68-4.61,6.68-13.45,11.29-10.77S504.91,666.66,502.22,671.27Z"
            />
          </g>
          <g>
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M223.36,357v-4.61A184.43,184.43,0,0,1,407.79,168h0c101.86,0,184.42,82.57,184.42,184.43V357c0,92.87-117.58,232.67-165,285.27a26.12,26.12,0,0,1-38.91,0C340.94,589.71,223.36,449.91,223.36,357Z"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillColor600}
              d="M354.12,354.63a53.65,53.65,0,0,0,53.67,53.66h0a53.64,53.64,0,0,0,53.66-53.66v-1A53.64,53.64,0,0,0,407.79,300h0a53.65,53.65,0,0,0-53.67,53.66"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(GeoModuleBrand)
